module.exports = __webpack_public_path__ + "static/img/3WCOFFEE.e3a416d6.png";